import React, { useState } from 'react'
import { GoogleMap, useJsApiLoader, DirectionsRenderer, Marker } from '@react-google-maps/api';
import goods from '../../Images/TruckMoving.gif';

const containerStyle = {
    width: '88vw',
    height: '400px'
};

const myStyles = [
    {
        featureType: "poi",
        elementType: "all",
        stylers: [
            { visibility: "off" }
        ]
    }
];

function Map({ routes }) {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_MAPS_KEY.toString()
    });
    let directionsService;

    const [map, setMap] = React.useState(null);
    const [Directions, setDirections] = useState(null);

    const onLoad = React.useCallback(function callback(map) {
        directionsService = new window.google.maps.DirectionsService();

        const uniqueIds = [];
        const lastRoute = routes[routes.length - 1];
        const uniqueRoutes = routes.filter(element => {
            const isDuplicate = uniqueIds.includes(element.location);

            if (!isDuplicate) {
                uniqueIds.push(element.location);
                return true;
            }
        });

        if (uniqueRoutes.filter(item => item.location === lastRoute.location).length > 0) {
            uniqueRoutes.push(lastRoute);
        }

        var routesCount = uniqueRoutes.length;
        var routesPerCount = routesCount > 25 ? uniqueRoutes.length / 25 : 0;
        var RouteData = [];
        if (routesPerCount > 0) {
            RouteData = uniqueRoutes.filter((e, i) => i % Math.ceil(routesPerCount) === 0);
        }
        else {
            RouteData = uniqueRoutes;
        }

        const routesCopy = RouteData.map(route => {
            return {
                location: { lat: route.loc[0], lng: route.loc[1] },
                stopover: true
            };
        });


        const origin =
            routesCopy.length === 1
                ? new window.google.maps.LatLng(
                    routesCopy[0].location.lat,
                    routesCopy[0].location.lng
                )
                : routesCopy.shift().location;
        const destination =
            routesCopy.length === 1
                ? new window.google.maps.LatLng(
                    routesCopy[0].location.lat,
                    routesCopy[0].location.lng
                )
                : routesCopy.pop().location;
        //put all the remaining coordinates in waypoints after(pop and shift)
        const waypoints = routesCopy;

        //call getDirection function
        getDirection(origin, destination, waypoints);
    }, [])

    const getDirection = (origin, destination, waypoints) => {
        //this will check if there is a waypoint meaning the array  has 3 or more coordinates
        waypoints.length >= 1
            ? directionsService.route(
                {
                    origin: origin,
                    destination: destination,
                    travelMode: window.google.maps.TravelMode.DRIVING,
                    waypoints: waypoints
                },
                (result, status) => {
                    if (status === window.google.maps.DirectionsStatus.OK) {
                        //changing the state of directions to the result of direction service
                        setDirections(result);
                    } else {
                        console.error(`error fetching directions ${result}`);
                    }
                }
            )
            : directionsService.route(
                {
                    origin: origin,
                    destination: destination,
                    travelMode: window.google.maps.TravelMode.DRIVING
                },
                (result, status) => {
                    if (status === window.google.maps.DirectionsStatus.OK) {
                        //changing the state of directions to the result of direction service
                        setDirections(result);
                    } else {
                        console.error(`error fetching directions ${result}`);
                    }
                }
            );
    };

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={routes && routes.length > 0 ? {
                lat: routes[0].loc[0],
                lng: routes[0].loc[1]
            } : null}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            {Directions !== null && (
                <React.Fragment>
                    <DirectionsRenderer directions={Directions} />
                    <Marker zIndex={100} position={{
                        lat: routes[routes.length - 1].loc[0],
                        lng: routes[routes.length - 1].loc[1]
                    }} icon={{
                        url: goods, scaledSize: new window.google.maps.Size(45, 45)
                    }} />
                </React.Fragment>
            )}
            <></>
        </GoogleMap>
    ) : <></>
}

export default Map;